import { Fetch } from "./Fetch";

export const nativeBrowserFetch: Fetch = window.fetch.bind(window);
